import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import Pagination from 'components/pagination';
import useTicketsTable from 'hooks/useTicketsTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { Card } from 'react-bootstrap';

const TableLayout = ({ tickets, filters, setFilters }) => {
  const table = useTicketsTable({
    data: tickets.content,
    selection: true
  });

  return (
    <>
      <AdvanceTableProvider {...table}>
        <AdvanceTable
          table
          headerClassName="text-800 align-middle"
          rowClassName="btn-reveal-trigger align-middle"
          tableProps={{
            size: 'sm',
            className: 'fs-10 mb-0 overflow-hidden'
          }}
        />
      </AdvanceTableProvider>
      <Card.Footer>
        <Pagination data={tickets} filters={filters} setFilters={setFilters} />
      </Card.Footer>
    </>
  );
};

export default TableLayout;
